import { Injectable, EventEmitter } from "@angular/core";
import {
  SignalRService,
  SignalREventService,
  AnalyticsFilter,
  ManualsDownloadedData,
  ManualsDownloadedDataIncluded,
  AnalyticsDataResponse,
  AnalyticsTypeEnum,
  ManualsOpenedData,
  ManualsCurrentlyOpenData,
  ManualsCreatedOrUpdatedData,
  ManualsPrintedData,
  AnnotationsSentData,
  SearchTermsUsedData,
  PagesOfManualsViewedData,
  ManualLanguagesData,
  ApplicationLanguagesData,
  ApplicationVersionsData,
  UsersCreatedData,
  UsersCreatedDataTotal,
  UsersRemovedData,
  UsersRemovedDataTotal,
  UsersLockedData,
  UsersLockedDataTotal,
  UsersCurrentData,
  UsersTotalData,
  UserSessionsChartData,
  UserSessionsData,
  AppUsageChartData,
  LoggingService,
  GlobalSearchTermsData,
  GlobalSearchTermDocumentsData,
  CombinedSearchTermsData,
  OsVersionsData,
} from "../index";
import { UserAnalyticConfiguration } from "../model/charts/user-analytic-configurations.model";

@Injectable({
  providedIn: "root", // Ensures this service is available globally through dependency injection
})
export class AnalyticsService {
  public manualsDownloadedDataLoading: boolean = false;
  public userAnalyticsConfigurationsDataLoading: boolean = false;
  public manualsDownloadedMostDataLoading: boolean = false;
  public manualsDownloadedLeastDataLoading: boolean = false;
  public manualsDownloadedNeverDataLoading: boolean = false;
  public manualsOpenedDataLoading: boolean = false;
  public manualsCurrentlyOpenDataLoading: boolean = false;
  public manualsUpdatedDataLoading: boolean = false;
  public manualsCreatedDataLoading: boolean = false;
  public manualsPrintedDataLoading: boolean = false;
  public annotationsSentDataLoading: boolean = false;
  public searchTermsUsedDataLoading: boolean = false;
  public pagesOfManualsViewedDataLoading: boolean = false;
  public manualLanguagesDataLoading: boolean = false;
  public applicationLanguagesDataLoading: boolean = false;
  public applicationVersionsDataLoading: boolean = false;
  public osTypeDataLoading: boolean = false;
  public osVersionDataLoading: boolean = false;
  public usersCreatedDataLoading: boolean = false;
  public usersCreatedDataTotalLoading: boolean = false;
  public usersRemovedDataLoading: boolean = false;
  public usersRemovedDataTotalLoading: boolean = false;
  public usersLockedDataLoading: boolean = false;
  public usersLockedDataTotalLoading: boolean = false;
  public usersCurrentDataLoading: boolean = false;
  public usersTotalDataLoading: boolean = false;
  public usersCurrentlyOnlineDataLoading: boolean = false;
  public userSessionsDataLoading: boolean = false;
  public appUsageDataLoading: boolean = false;
  public globalSearchTermsDataLoading: boolean = false;
  public globalSearchTermDocumentsDataLoading: boolean = false;
  public combinedSearchTermsDataLoading: boolean = false;


  private manualsDownloadedFallbackTimeoutId: any = null;
  private userAnalyticsConfigurationsFallbackTimeoutId: any = null;
  private manualsDownloadedMostFallbackTimeoutId: any = null;
  private manualsDownloadedLeastFallbackTimeoutId: any = null;
  private manualsDownloadedNeverFallbackTimeoutId: any = null;
  private manualsOpenedFallbackTimeoutId: any = null;
  private manualsCurrentlyOpenFallbackTimeoutId: any = null;
  private manualsUpdatedFallbackTimeoutId: any = null;
  private manualsCreatedFallbackTimeoutId: any = null;
  private manualsPrintedFallbackTimeoutId: any = null;
  private annotationsSentFallbackTimeoutId: any = null;
  private searchTermsUsedFallbackTimeoutId: any = null;
  private pagesOfManualsViewedFallbackTimeoutId: any = null;
  private manualLanguagesFallbackTimeoutId: any = null;
  private applicationLanguagesFallbackTimeoutId: any = null;
  private applicationVersionsFallbackTimeoutId: any = null;
  private osTypeFallbackTimeoutId: any = null;
  private osVersionFallbackTimeoutId: any = null;
  private usersCreatedFallbackTimeoutId: any = null;
  private usersCreatedTotalFallbackTimeoutId: any = null;
  private usersRemovedFallbackTimeoutId: any = null;
  private usersRemovedTotalFallbackTimeoutId: any = null;
  private usersLockedFallbackTimeoutId: any = null;
  private usersLockedTotalFallbackTimeoutId: any = null;
  private usersCurrentFallbackTimeoutId: any = null;
  private usersTotalFallbackTimeoutId: any = null;
  private usersCurrentlyOnlineFallbackTimeoutId: any = null;
  private userSessionsFallbackTimeoutId: any = null;
  private appUsageFallbackTimeoutId: any = null;
  private globalSearchTermsFallbackTimeoutId: any = null;
  private globalSearchTermDocumentsFallbackTimeoutId: any = null;
  private combinedSearchTermsFallbackTimeoutId: any = null;


  public refreshData: EventEmitter<boolean> = new EventEmitter<boolean>();

  public manualsDownloadedDataChange: EventEmitter<ManualsDownloadedData> =
    new EventEmitter<ManualsDownloadedData>();
  public manualsDownloadedMostDataChange: EventEmitter<ManualsDownloadedData> =
    new EventEmitter<ManualsDownloadedData>();
  public manualsDownloadedLeastDataChange: EventEmitter<ManualsDownloadedData> =
    new EventEmitter<ManualsDownloadedData>();
  public manualsDownloadedNeverDataChange: EventEmitter<ManualsDownloadedData> =
    new EventEmitter<ManualsDownloadedData>();

  public manualsOpendedDataChange: EventEmitter<ManualsOpenedData> =
    new EventEmitter<ManualsOpenedData>();
  public manualsCurrentlyOpenDataChange: EventEmitter<ManualsCurrentlyOpenData> =
    new EventEmitter<ManualsCurrentlyOpenData>();
  public manualsUpdatedDataChange: EventEmitter<ManualsCreatedOrUpdatedData> =
    new EventEmitter<ManualsCreatedOrUpdatedData>();
  public manualsCreatedDataChange: EventEmitter<ManualsCreatedOrUpdatedData> =
    new EventEmitter<ManualsCreatedOrUpdatedData>();
  public manualsPrintedDataChange: EventEmitter<ManualsPrintedData> =
    new EventEmitter<ManualsPrintedData>();
  public annotationsSentDataChange: EventEmitter<AnnotationsSentData> =
    new EventEmitter<AnnotationsSentData>();
  public searchTermsUsedDataChange: EventEmitter<SearchTermsUsedData> =
    new EventEmitter<SearchTermsUsedData>();
  public pagesOfManualsViewedDataChange: EventEmitter<PagesOfManualsViewedData> =
    new EventEmitter<PagesOfManualsViewedData>();
  public manualLanguagesDataChange: EventEmitter<ManualLanguagesData> =
    new EventEmitter<ManualLanguagesData>();

  public applicationLanguagesDataChage: EventEmitter<ApplicationLanguagesData> =
    new EventEmitter<ApplicationLanguagesData>();
  public applicationVersionsDataChange: EventEmitter<ApplicationVersionsData> =
    new EventEmitter<ApplicationVersionsData>();
  public osTypeDataChange: EventEmitter<ApplicationVersionsData> =
    new EventEmitter<ApplicationVersionsData>();
  public osVersionDataChange: EventEmitter<OsVersionsData> =
    new EventEmitter<OsVersionsData>();
  public usersCreatedDataChange: EventEmitter<UsersCreatedData> =
    new EventEmitter<UsersCreatedData>();
  public usersCreatedDataTotalChange: EventEmitter<UsersCreatedDataTotal> =
    new EventEmitter<UsersCreatedDataTotal>();
  public usersRemovedDataChange: EventEmitter<UsersRemovedData> =
    new EventEmitter<UsersRemovedData>();
  public usersRemovedDataTotalChange: EventEmitter<UsersRemovedDataTotal> =
    new EventEmitter<UsersRemovedDataTotal>();
  public usersLockedDataChange: EventEmitter<UsersLockedData> =
    new EventEmitter<UsersLockedData>();
  public usersLockedDataTotalChange: EventEmitter<UsersLockedDataTotal> =
    new EventEmitter<UsersLockedDataTotal>();
  public usersCurrentDataChange: EventEmitter<UsersCurrentData> =
    new EventEmitter<UsersCurrentData>();
  public usersTotalDataChange: EventEmitter<UsersTotalData> =
    new EventEmitter<UsersTotalData>();
  public usersCurrentlyOnlineDataChange: EventEmitter<UserSessionsChartData> =
    new EventEmitter<UserSessionsChartData>();
  public userSessionsDataChange: EventEmitter<UserSessionsData> =
    new EventEmitter<UserSessionsData>();
  public appUsageDataChange: EventEmitter<AppUsageChartData> =
    new EventEmitter<AppUsageChartData>();

  public globalSearchTermsDataChange: EventEmitter<GlobalSearchTermsData> =
    new EventEmitter<GlobalSearchTermsData>();
  public globalSearchTermDocumentsDataChange: EventEmitter<GlobalSearchTermDocumentsData> =
      new EventEmitter<GlobalSearchTermDocumentsData>();
  public combinedSearchTermsDataChange: EventEmitter<CombinedSearchTermsData> =
      new EventEmitter<CombinedSearchTermsData>();

  public userAnalyticsConfigurationsDataChange: EventEmitter<
    UserAnalyticConfiguration[]
  > = new EventEmitter<UserAnalyticConfiguration[]>();
  public userAnalyticsConfigurationChartDisplayOptionsChange: EventEmitter<UserAnalyticConfiguration> =
    new EventEmitter<UserAnalyticConfiguration>();

  //Important: All analytics responses included useful meta data, as
  // public downloadedManualsMetaData: AnalyticsDataResponse = new AnalyticsDataResponse()
  // public mostDownloadedManualsMetaData: AnalyticsDataResponse = new AnalyticsDataResponse()
  // public leastDownloadedManualsMetaData: AnalyticsDataResponse = new AnalyticsDataResponse()
  // public notDownloadedManualsMetaData: AnalyticsDataResponse = new AnalyticsDataResponse()
  // etc

  public userAnalyticsConfigurationsData: UserAnalyticConfiguration[] | null =
    null;

  constructor(
    private _signalRService: SignalRService,
    private _signalREventService: SignalREventService,
    private _loggingService: LoggingService
  ) {
    this.registerOnServerEvents();
  }

  // TODO GLOBAL SEARCH: Add methods to invoke the SignalR methods for
  // global search terms and global search term documents.
  // This will require the addition of the correct data models to the
  // app -> shared -> model folder.  Don't forget to update the index.ts
  // file in the shared folder to reference the new models.

  public getAllDownloadedManualsData(filterSettings: AnalyticsFilter) {
    if (this.manualsDownloadedDataLoading) return;
    this.manualsDownloadedDataLoading = true;
    clearTimeout(this.manualsDownloadedFallbackTimeoutId);

    this._loggingService.log(
      "analyticsService - invoke getAllDownloadedManualsData: ",
      filterSettings
    );

    this._signalRService.invoke("GetAllDownloadedManualsData", filterSettings);
    this.manualsDownloadedFallbackTimeoutId = setTimeout(() => {
      this.manualsDownloadedDataLoading = false;
    }, 2500);
  }

  public getMostDownloadedManualsData(filterSettings: AnalyticsFilter) {
    if (this.manualsDownloadedMostDataLoading) return;
    this.manualsDownloadedMostDataLoading = true;
    clearTimeout(this.manualsDownloadedMostFallbackTimeoutId);

    this._loggingService.log(
      "analyticsService - invoke getMostDownloadedManualsData: ",
      filterSettings
    );

    this._signalRService.invoke("GetMostDownloadedManualsData", filterSettings);
    this.manualsDownloadedMostFallbackTimeoutId = setTimeout(() => {
      this.manualsDownloadedMostDataLoading = false;
    }, 2500);
  }

  public getLeastDownloadedManualsData(filterSettings: AnalyticsFilter) {
    if (this.manualsDownloadedLeastDataLoading) return;
    this.manualsDownloadedLeastDataLoading = true;
    clearTimeout(this.manualsDownloadedLeastFallbackTimeoutId);

    this._loggingService.log(
      "analyticsService - invoke getLeastDownloadedManualsData: ",
      filterSettings
    );

    this._signalRService.invoke(
      "GetLeastDownloadedManualsData",
      filterSettings
    );
    this.manualsDownloadedLeastFallbackTimeoutId = setTimeout(() => {
      this.manualsDownloadedLeastDataLoading = false;
    }, 2500);
  }

  public getNotDownloadedManualsData(filterSettings: AnalyticsFilter) {
    if (this.manualsDownloadedNeverDataLoading) return;
    this.manualsDownloadedNeverDataLoading = true;
    clearTimeout(this.manualsDownloadedNeverFallbackTimeoutId);

    this._loggingService.log(
      "analyticsService - invoke getNotDownloadedManualsData: ",
      filterSettings
    );

    this._signalRService.invoke("GetNotDownloadedManualsData", filterSettings);
    this.manualsDownloadedNeverFallbackTimeoutId = setTimeout(() => {
      this.manualsDownloadedNeverDataLoading = false;
    }, 2500);
  }

  public getManualsOpenedData(filterSettings: AnalyticsFilter) {
    if (this.manualsOpenedDataLoading) return;
    this.manualsOpenedDataLoading = true;
    clearTimeout(this.manualsOpenedFallbackTimeoutId);

    this._loggingService.log(
      "analyticsService - invoke getManualsOpenedData: ",
      filterSettings
    );

    this._signalRService.invoke("GetManualsOpenedData", filterSettings);
    this.manualsOpenedFallbackTimeoutId = setTimeout(() => {
      this.manualsOpenedDataLoading = false;
    }, 2500);
  }

  public getManualsCurrentlyOpenData(filterSettings: AnalyticsFilter) {
    if (this.manualsCurrentlyOpenDataLoading) return;
    this.manualsCurrentlyOpenDataLoading = true;
    clearTimeout(this.manualsCurrentlyOpenFallbackTimeoutId);

    this._loggingService.log(
      "analyticsService - invoke getManualsCurrentlyOpenData: ",
      filterSettings
    );

    this._signalRService.invoke("GetManualsCurrentlyOpenData", filterSettings);
    this.manualsCurrentlyOpenFallbackTimeoutId = setTimeout(() => {
      this.manualsCurrentlyOpenDataLoading = false;
    }, 2500);
  }

  public getUpdatedManualsData(filterSettings: AnalyticsFilter) {
    if (this.manualsUpdatedDataLoading) return;
    this.manualsUpdatedDataLoading = true;
    clearTimeout(this.manualsUpdatedFallbackTimeoutId);

    this._loggingService.log(
      "analyticsService - invoke getUpdatedManualsData: ",
      filterSettings
    );

    this._signalRService.invoke("GetUpdatedManualsData", filterSettings);
    this.manualsUpdatedFallbackTimeoutId = setTimeout(() => {
      this.manualsUpdatedDataLoading = false;
    }, 2500);
  }

  public getCreatedManualsData(filterSettings: AnalyticsFilter) {
    if (this.manualsCreatedDataLoading) return;
    this.manualsCreatedDataLoading = true;
    clearTimeout(this.manualsCreatedFallbackTimeoutId);

    this._loggingService.log(
      "analyticsService - invoke getCreatedManualsData: ",
      filterSettings
    );

    this._signalRService.invoke("GetCreatedManualsData", filterSettings);
    this.manualsCreatedFallbackTimeoutId = setTimeout(() => {
      this.manualsCreatedDataLoading = false;
    }, 2500);
  }

  //TODO: change names to match manuals implemented names
  public getDocumentsPrintedData(filterSettings: AnalyticsFilter) {
    if (this.manualsPrintedDataLoading) return;
    this.manualsPrintedDataLoading = true;
    clearTimeout(this.manualsPrintedFallbackTimeoutId);

    this._loggingService.log(
      "analyticsService - invoke getDocumentsPrintedData: ",
      filterSettings
    );

    this._signalRService.invoke("GetDocumentsPrintedData", filterSettings);
    this.manualsPrintedFallbackTimeoutId = setTimeout(() => {
      this.manualsPrintedDataLoading = false;
    }, 2500);
  }

  public getAnnotationsSentData(filterSettings: AnalyticsFilter) {
    if (this.annotationsSentDataLoading) return;
    this.annotationsSentDataLoading = true;
    clearTimeout(this.annotationsSentFallbackTimeoutId);

    this._loggingService.log(
      "analyticsService - invoke getAnnotationsSentData: ",
      filterSettings
    );

    this._signalRService.invoke("GetAnnotationsSentData", filterSettings);
    this.annotationsSentFallbackTimeoutId = setTimeout(() => {
      this.annotationsSentDataLoading = false;
    }, 2500);
  }

  public getSearchTermsUsedData(filterSettings: AnalyticsFilter) {
    if (this.searchTermsUsedDataLoading) return;
    this.searchTermsUsedDataLoading = true;
    clearTimeout(this.searchTermsUsedFallbackTimeoutId);

    this._loggingService.log(
      "analyticsService - invoke getSearchTermsUsedData: ",
      filterSettings
    );

    this._signalRService.invoke("GetSearchTermsUsedData", filterSettings);
    this.searchTermsUsedFallbackTimeoutId = setTimeout(() => {
      this.searchTermsUsedDataLoading = false;
    }, 2500);
  }

  public getPagesOfManualsViewedData(filterSettings: AnalyticsFilter) {
    if (this.pagesOfManualsViewedDataLoading) return;
    this.pagesOfManualsViewedDataLoading = true;
    clearTimeout(this.pagesOfManualsViewedFallbackTimeoutId);

    this._loggingService.log(
      "analyticsService - invoke getPagesOfManualsViewedData: ",
      filterSettings
    );

    this._signalRService.invoke("GetPagesOfManualsViewedData", filterSettings);
    this.pagesOfManualsViewedFallbackTimeoutId = setTimeout(() => {
      this.pagesOfManualsViewedDataLoading = false;
    }, 2500);
  }

  public getManualLanguagesData(filterSettings: AnalyticsFilter) {
    if (this.manualLanguagesDataLoading) return;
    this.manualLanguagesDataLoading = true;
    clearTimeout(this.manualLanguagesFallbackTimeoutId);

    this._loggingService.log(
      "analyticsService - invoke getManualLanguagesData: ",
      filterSettings
    );

    this._signalRService.invoke("GetManualLanguagesData", filterSettings);
    this.manualLanguagesFallbackTimeoutId = setTimeout(() => {
      this.manualLanguagesDataLoading = false;
    }, 2500);
  }

  public getApplicationLanguagesData(filterSettings: AnalyticsFilter) {
    if (this.applicationLanguagesDataLoading) return;
    this.applicationLanguagesDataLoading = true;
    clearTimeout(this.applicationLanguagesFallbackTimeoutId);

    this._loggingService.log(
      "analyticsService - invoke getApplicationLanguagesData: ",
      filterSettings
    );

    this._signalRService.invoke("GetApplicationLanguagesData", filterSettings);
    this.applicationLanguagesFallbackTimeoutId = setTimeout(() => {
      this.applicationLanguagesDataLoading = false;
    }, 2500);
  }

  public getApplicationVersionsData(filterSettings: AnalyticsFilter) {
    if (this.applicationVersionsDataLoading) return;
    this.applicationVersionsDataLoading = true;
    clearTimeout(this.applicationVersionsFallbackTimeoutId);

    this._loggingService.log(
      "analyticsService - invoke getApplicationVersionsData: ",
      filterSettings
    );

    this._signalRService.invoke("GetApplicationVersionsData", filterSettings);
    this.applicationVersionsFallbackTimeoutId = setTimeout(() => {
      this.applicationVersionsDataLoading = false;
    }, 2500);
  }

  public getOsTypeData(filterSettings: AnalyticsFilter) {
    if (this.osTypeDataLoading) return;
    this.osTypeDataLoading = true;
    clearTimeout(this.osTypeFallbackTimeoutId);

    this._loggingService.log(
      "analyticsService - invoke getOsTypeData: ",
      filterSettings
    );

    this._signalRService.invoke("GetOsTypeData", filterSettings);
    this.osTypeFallbackTimeoutId = setTimeout(() => {
      this.osTypeDataLoading = false;
    }, 2500);
  }

  public getOsVersionData(filterSettings: AnalyticsFilter) {
    if (this.osVersionDataLoading) return;
    this.osVersionDataLoading = true;
    clearTimeout(this.osVersionFallbackTimeoutId);

    this._loggingService.log(
      "analyticsService - invoke getOsVersionData: ",
      filterSettings
    );

    this._signalRService.invoke("GetOsVersionData", filterSettings);
    this.osVersionFallbackTimeoutId = setTimeout(() => {
      this.osVersionDataLoading = false;
    }, 2500);
  }

  public getCreatedUsersData(filterSettings: AnalyticsFilter) {
    if (this.usersCreatedDataLoading) return;
    this.usersCreatedDataLoading = true;
    clearTimeout(this.usersCreatedFallbackTimeoutId);

    this._loggingService.log(
      "analyticsService - invoke getCreatedUsersData: ",
      filterSettings
    );

    this._signalRService.invoke("GetCreatedUsersData", filterSettings);
    this.usersCreatedFallbackTimeoutId = setTimeout(() => {
      this.usersCreatedDataLoading = false;
    }, 2500);
  }

  public getCreatedUsersDataTotal(filterSettings: AnalyticsFilter) {
    if (this.usersCreatedDataTotalLoading) return;
    this.usersCreatedDataTotalLoading = true;
    clearTimeout(this.usersCreatedTotalFallbackTimeoutId);

    this._loggingService.log(
      "analyticsService - invoke getCreatedUsersDataTotal: ",
      filterSettings
    );

    this._signalRService.invoke("GetCreatedUsersDataTotal", filterSettings);
    this.usersCreatedTotalFallbackTimeoutId = setTimeout(() => {
      this.usersCreatedDataTotalLoading = false;
    }, 2500);
  }

  public getRemovedUsersData(filterSettings: AnalyticsFilter) {
    if (this.usersRemovedDataLoading) return;
    this.usersRemovedDataLoading = true;
    clearTimeout(this.usersRemovedFallbackTimeoutId);

    this._loggingService.log(
      "analyticsService - invoke getRemovedUsersData: ",
      filterSettings
    );

    this._signalRService.invoke("GetRemovedUsersData", filterSettings);
    this.usersRemovedFallbackTimeoutId = setTimeout(() => {
      this.usersRemovedDataLoading = false;
    }, 2500);
  }

  public getRemovedUsersDataTotal(filterSettings: AnalyticsFilter) {
    if (this.usersRemovedDataTotalLoading) return;
    this.usersRemovedDataTotalLoading = true;
    clearTimeout(this.usersRemovedTotalFallbackTimeoutId);

    this._loggingService.log(
      "analyticsService - invoke getRemovedUsersDataTotal: ",
      filterSettings
    );

    this._signalRService.invoke("GetRemovedUsersDataTotal", filterSettings);
    this.usersRemovedTotalFallbackTimeoutId = setTimeout(() => {
      this.usersRemovedDataTotalLoading = false;
    }, 2500);
  }

  public getLockedUsersData(filterSettings: AnalyticsFilter) {
    if (this.usersLockedDataLoading) return;
    this.usersLockedDataLoading = true;
    clearTimeout(this.usersLockedFallbackTimeoutId);

    this._loggingService.log(
      "analyticsService - invoke getLockedUsersData: ",
      filterSettings
    );

    this._signalRService.invoke("GetLockedUsersData", filterSettings);
    this.usersLockedFallbackTimeoutId = setTimeout(() => {
      this.usersLockedDataLoading = false;
    }, 2500);
  }

  public getLockedUsersDataTotal(filterSettings: AnalyticsFilter) {
    if (this.usersLockedDataTotalLoading) return;
    this.usersLockedDataTotalLoading = true;
    clearTimeout(this.usersLockedTotalFallbackTimeoutId);

    this._loggingService.log(
      "analyticsService - invoke getLockedUsersDataTotal: ",
      filterSettings
    );

    this._signalRService.invoke("GetLockedUsersDataTotal", filterSettings);
    this.usersLockedTotalFallbackTimeoutId = setTimeout(() => {
      this.usersLockedDataTotalLoading = false;
    }, 2500);
  }

  public getTotalCurrentsUsersData(filterSettings: AnalyticsFilter) {
    if (this.usersCurrentDataLoading) return;
    this.usersCurrentDataLoading = true;
    clearTimeout(this.usersCurrentFallbackTimeoutId);

    this._loggingService.log(
      "analyticsService - invoke getTotalCurrentsUsersData: ",
      filterSettings
    );

    this._signalRService.invoke("GetTotalCurrentsUsersData", filterSettings);
    this.usersCurrentFallbackTimeoutId = setTimeout(() => {
      this.usersCurrentDataLoading = false;
    }, 2500);
  }

  public getTotalUsersData(filterSettings: AnalyticsFilter) {
    if (this.usersTotalDataLoading) return;
    this.usersTotalDataLoading = true;
    clearTimeout(this.usersTotalFallbackTimeoutId);

    this._loggingService.log(
      "analyticsService - invoke getTotalUsersData: ",
      filterSettings
    );

    this._signalRService.invoke("GetTotalUsersData", filterSettings);
    this.usersTotalFallbackTimeoutId = setTimeout(() => {
      this.usersTotalDataLoading = false;
    }, 2500);
  }

  // for the filters on this one: only provide the time period of OneHour, TwoHours, or TwentyFourHours
  public getUsersCurrentlyOnlineData(filterSettings: AnalyticsFilter) {
    if (this.usersCurrentlyOnlineDataLoading) return;
    this.usersCurrentlyOnlineDataLoading = true;
    clearTimeout(this.usersCurrentlyOnlineFallbackTimeoutId);

    this._loggingService.log(
      "analyticsService - invoke getUsersCurrentlyOnlineData: ",
      filterSettings
    );

    this._signalRService.invoke("GetUsersCurrentlyOnlineData", filterSettings);
    this.usersCurrentlyOnlineFallbackTimeoutId = setTimeout(() => {
      this.usersCurrentlyOnlineDataLoading = false;
    }, 2500);
  }

  public getUserSessionsData(filterSettings: AnalyticsFilter) {
    if (this.userSessionsDataLoading) return;
    this.userSessionsDataLoading = true;
    clearTimeout(this.userSessionsFallbackTimeoutId);

    this._loggingService.log(
      "analyticsService - invoke getUserSessionsData: ",
      filterSettings
    );

    this._signalRService.invoke("GetUserSessionsData", filterSettings);
    this.userSessionsFallbackTimeoutId = setTimeout(() => {
      this.userSessionsDataLoading = false;
    }, 2500);
  }

  public getAppUsageData(filterSettings: AnalyticsFilter) {
    if (this.appUsageDataLoading) return;
    this.appUsageDataLoading = true;
    clearTimeout(this.appUsageFallbackTimeoutId);

    this._loggingService.log(
      "analyticsService - invoke getAppUsageData: ",
      filterSettings
    );

    this._signalRService.invoke("GetAppUsageData", filterSettings);
    this.appUsageFallbackTimeoutId = setTimeout(() => {
      this.appUsageDataLoading = false;
    }, 2500);
  }

  public getGlobalSearchTermsData(filterSettings: AnalyticsFilter) {
    if (this.globalSearchTermsDataLoading) return;
    this.globalSearchTermsDataLoading = true;
    clearTimeout(this.globalSearchTermsFallbackTimeoutId);

    this._loggingService.log(
      "analyticsService - invoke getGlobalSearchTermsData: ",
      filterSettings
    );

    this._signalRService.invoke("GetGlobalSearchTermsData", filterSettings);
    this.globalSearchTermsFallbackTimeoutId = setTimeout(() => {
      this.globalSearchTermsDataLoading = false;
    }, 2500);
  }

  public getGlobalSearchTermDocumentsData(filterSettings: AnalyticsFilter) {
    if (this.globalSearchTermDocumentsDataLoading) return;
    this.globalSearchTermDocumentsDataLoading = true;
    clearTimeout(this.globalSearchTermDocumentsFallbackTimeoutId);

    this._loggingService.log(
      "analyticsService - invoke getGlobalSearchTermDocumentsData: ",
      filterSettings
    );

    this._signalRService.invoke(
      "GetGlobalSearchTermDocumentsData",
      filterSettings
    );
    this.globalSearchTermDocumentsFallbackTimeoutId = setTimeout(() => {
      this.globalSearchTermDocumentsDataLoading = false;
    }, 2500);
    }

  public getCombinedSearchTermsData(filterSettings: AnalyticsFilter) {
    if (this.combinedSearchTermsDataLoading) return;
    this.combinedSearchTermsDataLoading = true;
    clearTimeout(this.combinedSearchTermsFallbackTimeoutId);

    this._loggingService.log(
      "analyticsService - invoke getCombinedSearchTermsData: ",
      filterSettings
    );

    this._signalRService.invoke("GetCombinedSearchTermsData", filterSettings);
    this.combinedSearchTermsFallbackTimeoutId = setTimeout(() => {
      this.combinedSearchTermsDataLoading = false;
    }, 2500);
}

  /**
   * Invoke the signalR method to get the user analytics configurations data
   * @param userid
   */
  public getUserAnalyticsConfigurationsData(userid: number) {
    // if (this.userAnalyticsConfigurationsDataLoading) {
    //     this._loggingService.log('analyticsService - getUserAnalyticsConfigurationsData - already loading, skip');
    //     return;
    // };
    // this.userAnalyticsConfigurationsDataLoading = true;
    // clearTimeout(this.userAnalyticsConfigurationsFallbackTimeoutId);

    this._loggingService.log(
      "analyticsService - invoke getUserAnalyticsConfigurationsData: ",
      userid
    );
    this._signalRService.invoke("GetUserAnalyticsConfigurationsData", userid);

    // this.userAnalyticsConfigurationsFallbackTimeoutId = setTimeout(() => {
    //     this.userAnalyticsConfigurationsDataLoading = false;
    // }, 500);
  }

  /**
   * Invoke the signalR method to set the user analytics configurations data
   * @param userAnalyticsConfiguration
   */
  public setUserAnalyticsConfigurationsData(
    userAnalyticsConfiguration: UserAnalyticConfiguration
  ) {
    if (!this.userAnalyticsConfigurationsData) {
      this.userAnalyticsConfigurationsData = [];
    }
    this._loggingService.log(
      "analyticsService - invoke setUserAnalyticsConfigurationsData: ",
      userAnalyticsConfiguration
    );
    this._signalRService.invoke(
      "SetUserAnalyticsConfigurationsData",
      userAnalyticsConfiguration.toJSON()
    );
  }

  public changeUserAnalyticsConfigurationChartDisplayOptions(
    userAnalyticsConfiguration: UserAnalyticConfiguration
  ) {
    if (!this.userAnalyticsConfigurationsData) {
      this.userAnalyticsConfigurationsData = [];
      this.userAnalyticsConfigurationsData.push(userAnalyticsConfiguration);
    }
    this._loggingService.log(
      "analyticsService - changeUserAnalyticsConfigurationChartDisplayOptions: ",
      userAnalyticsConfiguration
    );
    this.userAnalyticsConfigurationChartDisplayOptionsChange.emit(
      userAnalyticsConfiguration
    );
  }

  public refetchUserAnalyticsData(config: UserAnalyticConfiguration): void {
    this._loggingService.log(
      "analyticsService - refreshUserAnalyticsData:",
      config
    );
    this._signalRService.invoke(
      "SetUserAnalyticsConfigurationsData",
      config.toJSON()
    );
  }

  //#endregion
  //#region Analytics Frontend Service
  public refreshDataPoints(): void {
    this.refreshData.emit();
  }
  //#endregion

  //#region SignalR Events Receiving

  private onGetAnalyticsResponse(info: any): void {
    this._loggingService.log(
      "analyticsService - onGetAnalyticsResponse: ",
      info
    );

    //@ts-ignore
    const response: AnalyticsDataResponse = $.extend(
      new AnalyticsDataResponse(),
      info.Response
    );
    this._loggingService.log(
      "analyticsService - AnalyticsDataResponse: ",
      response
    );

    switch (response.AnalyticsType) {
      case AnalyticsTypeEnum.DownloadedManualsData:
        //@ts-ignore
        const downloadedManualsData = new ManualsDownloadedData(response.Data);
        this.onGetDownloadedManualsData(info.Includes, downloadedManualsData);
        this.manualsDownloadedDataLoading = false;
        clearTimeout(this.manualsDownloadedFallbackTimeoutId);
        break;
      case AnalyticsTypeEnum.ManualsOpenedData:
        //@ts-ignore
        const manualsOpenedData = new ManualsOpenedData(response.Data);

        //example of assigning metadata
        //this.manualsOpenedMetadata = response
        this.manualsOpendedDataChange.emit(manualsOpenedData);
        this.manualsOpenedDataLoading = false;
        clearTimeout(this.manualsOpenedFallbackTimeoutId);
        break;
      case AnalyticsTypeEnum.ManualsCurrentlyOpenData:
        //@ts-ignore
        const manualsCurrentlyOpenData = new ManualsCurrentlyOpenData(
          response.Data
        );
        this.manualsCurrentlyOpenDataChange.emit(manualsCurrentlyOpenData);
        this.manualsCurrentlyOpenDataLoading = false;
        clearTimeout(this.manualsCurrentlyOpenFallbackTimeoutId);
        break;
      case AnalyticsTypeEnum.UpdatedManualsData:
        //@ts-ignore
        const updatedManualsData = new ManualsCreatedOrUpdatedData(
          response.Data
        );
        this.manualsUpdatedDataChange.emit(updatedManualsData);
        this.manualsUpdatedDataLoading = false;
        clearTimeout(this.manualsUpdatedFallbackTimeoutId);
        break;
      case AnalyticsTypeEnum.CreatedManualsData:
        //@ts-ignore
        const createdManualsData = new ManualsCreatedOrUpdatedData(
          response.Data
        );
        this.manualsCreatedDataChange.emit(createdManualsData);
        this.manualsCreatedDataLoading = false;
        clearTimeout(this.manualsCreatedFallbackTimeoutId);
        break;
      case AnalyticsTypeEnum.DocumentsPrintedData:
        //@ts-ignore
        const documentsPrintedData = new ManualsPrintedData(response.Data);
        this.manualsPrintedDataChange.emit(documentsPrintedData);
        this.manualsPrintedDataLoading = false;
        clearTimeout(this.manualsPrintedFallbackTimeoutId);
        break;
      case AnalyticsTypeEnum.AnnotationsSentData:
        //@ts-ignore
        const annotationsSentData = new AnnotationsSentData(response.Data);
        this.annotationsSentDataChange.emit(annotationsSentData);
        this.annotationsSentDataLoading = false;
        clearTimeout(this.annotationsSentFallbackTimeoutId);
        break;
      case AnalyticsTypeEnum.SearchTermsUsedData:
        //@ts-ignore
        const searchTermsUsedData = new SearchTermsUsedData(response.Data);
        this.searchTermsUsedDataChange.emit(searchTermsUsedData);
        this.searchTermsUsedDataLoading = false;
        clearTimeout(this.searchTermsUsedFallbackTimeoutId);
        break;
      case AnalyticsTypeEnum.PagesOfManualsViewedData:
        //@ts-ignore
        const pagesOfManualsViewedData = new PagesOfManualsViewedData(
          response.Data
        );
        this.pagesOfManualsViewedDataChange.emit(pagesOfManualsViewedData);
        this.pagesOfManualsViewedDataLoading = false;
        clearTimeout(this.pagesOfManualsViewedFallbackTimeoutId);
        break;
      case AnalyticsTypeEnum.ManualLanguagesData:
        //@ts-ignore
        const manualLanguagesData = new ManualLanguagesData(response.Data);
        this.manualLanguagesDataChange.emit(manualLanguagesData);
        this.manualLanguagesDataLoading = false;
        clearTimeout(this.manualLanguagesFallbackTimeoutId);
        break;
      case AnalyticsTypeEnum.ApplicationLanguagesData:
        //@ts-ignore
        const applicationLanguagesData = new ApplicationLanguagesData(
          response.Data
        );
        this.applicationLanguagesDataChage.emit(applicationLanguagesData);
        this.applicationLanguagesDataLoading = false;
        clearTimeout(this.applicationLanguagesFallbackTimeoutId);
        break;
      case AnalyticsTypeEnum.ApplicationVersionsData:
        //@ts-ignore
        const applicationVersionsData = new ApplicationVersionsData(
          response.Data
        );
        this.applicationVersionsDataChange.emit(applicationVersionsData);
        this.applicationVersionsDataLoading = false;
        clearTimeout(this.applicationVersionsFallbackTimeoutId);
        break;
      case AnalyticsTypeEnum.OsTypeData:
        //@ts-ignore
        const osTypeData = new ApplicationVersionsData(response.Data);
        this.osTypeDataChange.emit(osTypeData);
        this.osTypeDataLoading = false;
        clearTimeout(this.osTypeFallbackTimeoutId);
        break;
      case AnalyticsTypeEnum.OsVersionData:
        //@ts-ignore
        const osVersionData = new OsVersionsData(response.Data);
        this.osVersionDataChange.emit(osVersionData);
        this.osVersionDataLoading = false;
        clearTimeout(this.osVersionFallbackTimeoutId);
        break;
      case AnalyticsTypeEnum.CreatedUsersData:
        //@ts-ignore
        const createdUsersData = new UsersCreatedData(response.Data);
        this.usersCreatedDataChange.emit(createdUsersData);
        this.usersCreatedDataLoading = false;
        clearTimeout(this.usersCreatedFallbackTimeoutId);
        break;
      case AnalyticsTypeEnum.CreatedUsersDataTotal:
        //@ts-ignore
        const createdUsersDataTotal = new UsersCreatedDataTotal(response.Data);
        this.usersCreatedDataTotalChange.emit(createdUsersDataTotal);
        this.usersCreatedDataTotalLoading = false;
        clearTimeout(this.usersCreatedTotalFallbackTimeoutId);
        break;
      case AnalyticsTypeEnum.RemovedUsersData:
        //@ts-ignore
        const removedUsersData = new UsersRemovedData(response.Data);
        this.usersRemovedDataChange.emit(removedUsersData);
        this.usersRemovedDataLoading = false;
        clearTimeout(this.usersRemovedFallbackTimeoutId);
        break;
      case AnalyticsTypeEnum.RemovedUsersDataTotal:
        //@ts-ignore
        const removedUsersDataTotal = new UsersRemovedDataTotal(response.Data);
        this.usersRemovedDataTotalChange.emit(removedUsersDataTotal);
        this.usersRemovedDataTotalLoading = false;
        clearTimeout(this.usersRemovedTotalFallbackTimeoutId);
        break;
      case AnalyticsTypeEnum.LockedUsersData:
        //@ts-ignore
        const lockedUsersData = new UsersLockedData(response.Data);
        this.usersLockedDataChange.emit(lockedUsersData);
        this.usersLockedDataLoading = false;
        clearTimeout(this.usersLockedFallbackTimeoutId);
        break;
      case AnalyticsTypeEnum.LockedUsersDataTotal:
        //@ts-ignore
        const lockedUsersDataTotal = new UsersLockedDataTotal(response.Data);
        this.usersLockedDataTotalChange.emit(lockedUsersDataTotal);
        this.usersLockedDataTotalLoading = false;
        clearTimeout(this.usersLockedTotalFallbackTimeoutId);
        break;
      case AnalyticsTypeEnum.TotalCurrentUsersData:
        //@ts-ignore
        const totalCurrentUsersData = new UsersCurrentData(response.Data);
        this.usersCurrentDataChange.emit(totalCurrentUsersData);
        this.usersCurrentDataLoading = false;
        clearTimeout(this.usersCurrentFallbackTimeoutId);
        break;
      case AnalyticsTypeEnum.TotalUsersData:
        const totalUsersData = new UsersTotalData(response.Data);
        this.usersTotalDataChange.emit(totalUsersData);
        this.usersTotalDataLoading = false;
        clearTimeout(this.usersTotalFallbackTimeoutId);
        break;
      case AnalyticsTypeEnum.UsersCurrentlyOnlineData:
        //@ts-ignore
        const usersCurrentlyOnlineData = new UserSessionsChartData(
          response.Data
        );
        this.usersCurrentlyOnlineDataChange.emit(usersCurrentlyOnlineData);
        this.usersCurrentlyOnlineDataLoading = false;
        clearTimeout(this.usersCurrentlyOnlineFallbackTimeoutId);
        break;
      case AnalyticsTypeEnum.UserSessionsData:
        //@ts-ignore
        const userSessionsData = new UserSessionsData(response.Data);
        this.userSessionsDataChange.emit(userSessionsData);
        this.userSessionsDataLoading = false;
        clearTimeout(this.userSessionsFallbackTimeoutId);
        break;
      case AnalyticsTypeEnum.AppUsageData:
        //@ts-ignore
        const appUsageData = new AppUsageChartData(response.Data);
        this.appUsageDataChange.emit(appUsageData);
        this.appUsageDataLoading = false;
        clearTimeout(this.appUsageFallbackTimeoutId);
        break;
      case AnalyticsTypeEnum.GlobalSearchTermsData:
        //@ts-ignore
        const globalSearchTermsData = $.extend(
          new GlobalSearchTermsData(),
          response.Data
        );
        this.globalSearchTermsDataChange.emit(globalSearchTermsData);
        this.globalSearchTermsDataLoading = false;
        clearTimeout(this.globalSearchTermsFallbackTimeoutId);
        break;
      case AnalyticsTypeEnum.GlobalSearchTermDocumentsData:
        //@ts-ignore
        const globalSearchTermDocumentsData = $.extend(
          new GlobalSearchTermDocumentsData(),
          response.Data
        );
        this.globalSearchTermDocumentsDataChange.emit(
          globalSearchTermDocumentsData
        );
        this.globalSearchTermDocumentsDataLoading = false;
        clearTimeout(this.globalSearchTermDocumentsFallbackTimeoutId);
            break;
      case AnalyticsTypeEnum.CombinedSearchTermsData:
        const combinedSearchTermsData = $.extend(
          new CombinedSearchTermsData(),
          response.Data
        );
        this.combinedSearchTermsDataChange.emit(combinedSearchTermsData);
        this.combinedSearchTermsDataLoading = false;
        clearTimeout(this.combinedSearchTermsFallbackTimeoutId);
        break;
      default:
        console.error(
          `AnalyticsType not recognized: ${response.AnalyticsType}`
        );
        break;
    }
  }

  private setUserAnalyticsConfigurationsDataResponse(info: any): void {
    this.onGetUserAnalyticsConfigurationsData(info);
  }

  private onGetUserAnalyticsConfigurationsData(info: any): void {
    //@ts-ignore
    this._loggingService.log(
      "analyticsService - onGetUserAnalyticsConfigurationsData: ",
      info
    );
    clearTimeout(this.userAnalyticsConfigurationsFallbackTimeoutId);

    if (!info || !info.Response || !Array.isArray(info.Response)) {
      this._loggingService.log(
        "analyticsService - onGetUserAnalyticsConfigurationsData - no data"
      );
      this.userAnalyticsConfigurationsDataChange.emit(null);
      return;
    }
    const userAnalyticsConfigurations = info.Response.map((item: any) =>
      UserAnalyticConfiguration.fromJSON(item)
    );
    this._loggingService.log(
      "analyticsService - userAnalyticsConfigurations - after map: ",
      userAnalyticsConfigurations
    );

    this.userAnalyticsConfigurationsData = userAnalyticsConfigurations;
    this.userAnalyticsConfigurationsDataChange.emit(
      userAnalyticsConfigurations
    );
  }

  private onGetDownloadedManualsData(
    includes: ManualsDownloadedDataIncluded,
    downloadedManualsData: ManualsDownloadedData
  ): void {
    switch (includes) {
      case ManualsDownloadedDataIncluded.All:
        this.manualsDownloadedDataChange.emit(downloadedManualsData);
        break;
      case ManualsDownloadedDataIncluded.Most:
        this.manualsDownloadedMostDataChange.emit(downloadedManualsData);
        break;
      case ManualsDownloadedDataIncluded.Least:
        this.manualsDownloadedLeastDataChange.emit(downloadedManualsData);
        break;
      case ManualsDownloadedDataIncluded.NoDownloads:
        this.manualsDownloadedNeverDataChange.emit(downloadedManualsData);
        break;
      default:
        console.error("Includes data not recognized.");
    }
  }

  //#endregion

  private registerOnServerEvents() {
    this._signalREventService.register(
      "AnalyticsService",
      "getAnalyticsResponse",
      (info: any) => this.onGetAnalyticsResponse(info)
    );
    this._signalREventService.register(
      "AnalyticsService",
      "getUserAnalyticsConfigurationsDataResponse",
      (info: any) => this.onGetUserAnalyticsConfigurationsData(info)
    );
    this._signalREventService.register(
      "AnalyticsService",
      "setUserAnalyticsConfigurationsDataResponse",
      (info: any) => this.setUserAnalyticsConfigurationsDataResponse(info)
    );
  }
}
